module.exports = __webpack_public_path__ + "static/img/order_icon4.64df75f0.svg";